import type { FC } from 'react';

import type { WizardStep, WizardStepConfig } from '../../types';
import WizardStepperItem from './WizardStepperItem';

interface Props {
  currentStepIndex: number;
  onStepClick: (step: WizardStep) => void;
  steps: WizardStepConfig[];
  visitedSteps: WizardStep[];
}

const WizardStepper: FC<Props> = (props) => {
  const { currentStepIndex, onStepClick, steps, visitedSteps } = props;

  return (
    <nav
      className="relative flex shrink-0 justify-center border-b border-grey-lighter py-4 shadow-fixed-top"
      data-component="wizard-stepper"
    >
      <ol className="flex w-full max-w-6xl px-6">
        {steps.map((step: WizardStepConfig, index: number) => {
          const isVisited: boolean = visitedSteps.includes(step.id);

          return (
            <WizardStepperItem
              isClickable={isVisited}
              isCompleted={index < currentStepIndex}
              isCurrent={index === currentStepIndex}
              isFirst={index === 0}
              key={step.id}
              label={step.label}
              onClick={(): void => onStepClick(step.id)}
            />
          );
        })}
      </ol>
    </nav>
  );
};

export type { Props as WizardStepperProps };
export default WizardStepper;
